import React, { Component } from 'react';
import { Form } from '@ant-design/compatible';
import { Input, Button } from 'antd';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import DateRangePicker from '../../../components/DateRangePicker';
import PropTypes from 'prop-types';

dayjs.extend(customParseFormat);

class assetJourneyHistoryFilterForm extends Component {
    constructor (props) {
        super(props);
        let currentAssetFilters = null;
        if (props?.assetViewVideoFilters?.length) {
            const matches = props.assetViewVideoFilters.filter(f => parseInt(f.assetId) === parseInt(props.assetId));
            if (matches?.length) {
                currentAssetFilters = matches[0]?.filters;
            }
        }
        this.state = { currentAssetFilters };
    }

    componentDidUpdate(prevProps) {
        const { assetViewVideoFilters, assetId } = this.props;
        
        if (prevProps.assetViewVideoFilters !== assetViewVideoFilters) {
            let currentAssetFilters = null;
            if (assetViewVideoFilters?.length) {
                const matches = assetViewVideoFilters.filter(f => parseInt(f.assetId) === parseInt(assetId));
                if (matches?.length) {
                    currentAssetFilters = matches[0]?.filters;
                }
            }
            this.setState({ currentAssetFilters });
        }
    }

    submitForm = (e) => {
        const { onSubmit } = this.props;

        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                onSubmit(values);
            }
        });
    };

    render() {
        const { form, telematicsRetentionDays } = this.props;
        const { currentAssetFilters } = this.state;
        
        const { getFieldDecorator, getFieldValue } = form;
        
        return (
            <Form 
                onSubmit={this.submitForm} 
                layout="vertical"
            >
                <DateRangePicker
                    getFieldDecorator={getFieldDecorator}
                    getFieldValue={getFieldValue}
                    minDate={dayjs().subtract(telematicsRetentionDays, 'days')}
                    dateFromInitialValue={dayjs(currentAssetFilters?.date_from) || dayjs()}
                    dateToInitialValue={dayjs(currentAssetFilters?.date_to) || dayjs()}
                    dataTestId='asset-details-video-filter_date-range-picker'
                />
                <Form.Item label="Current Location">
                    {getFieldDecorator('current_location', { initialValue: currentAssetFilters?.current_location || null })(
                        <Input 
                            placeholder="Enter Current Location" 
                            data-testid='asset-details-video-filter_location-input'
                        />,
                    )}
                </Form.Item>
                <div className="mt-2 mb-1 text-center">
                    <Button
                        htmlType="submit"
                        type="primary"
                        data-testid='asset-details-video-filter_filter-btn'
                    >
                        Filter
                    </Button>
                </div>
            </Form>
        );
    }
}

const assetJourneyHistoryFilter = Form.create({ name: 'event_filter_form' })(assetJourneyHistoryFilterForm);

assetJourneyHistoryFilter.propTypes = {
    assetViewVideoFilters: PropTypes.object,
    assetId: PropTypes.number,
    telematicsRetentionDays: PropTypes.number,
    form: PropTypes.object,
}

function mapStateToProps(state, ownProps) {
    return {
        ...ownProps,
        telematicsRetentionDays: state.user.userCompany.telematics_retention_days,
        assetViewVideoFilters: state.asset.assetViewVideoFilters,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
        }, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(assetJourneyHistoryFilter);
